import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";

import { logout } from "@/features/auth/api";
import { getSessionUser } from "@/lib/api/endpoints";
import { keys } from "@/lib/api/keys";

/**
 * Quién está adentro.
 *
 * La sesión es la única consulta que se cachea de verdad: no cambia mientras
 * dura la visita y la piden el guard, el shell y media aplicación. Con
 * `staleTime: 0` como el resto, cada pantalla dispararía su propio `/me` — que
 * a la latencia que tenemos son segundos regalados.
 */
export function useSession() {
  return useQuery({
    queryKey: keys.session,
    queryFn: getSessionUser,
    staleTime: 5 * 60 * 1000,
    // Sin sesión el guard ya manda al login; reintentar solo demora ese rebote.
    retry: false,
  });
}

export function useLogout() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: logout,
    onSuccess: async () => {
      // Vaciar la caché antes de navegar, no después: si queda algo, la
      // pantalla de login puede llegar a pintar datos del usuario anterior
      // mientras React desmonta lo de atrás.
      queryClient.clear();
      await navigate("/login", { replace: true });
    },
  });
}
